// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3A712","logo":"header-module--logo--dkMqu","headerMenu":"header-module--headerMenu--1FOKj"};